<!--
 * @Description: 卸料视频查看
-->
<template>
    <el-dialog :visible.sync="visible" width="740px" title="卸料视频" @close="onClose" @open="onOpen">
      <div class="dialoginfo">
        <div class="FZYimgMp4list">
          <div v-if="config && config.length>0">
            <video v-for="(item,index) in config" :key="index" width="300" height="300" style="margin:5px 10px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);" :src="'/file/'+item" controls>
              您的浏览器不支持 HTML5 video 标签。
            </video>
          </div>
          <p v-else>暂无卸料视频</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="onClose">关 闭</el-button>
      </span>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
            };
        },
        props: {
            config: {
                type: Object,
                default: () => ({}),
            },
            visible: {
                type: Boolean,
            },
        },
        methods: {
            onOpen() {},
            onClose() {
                this.$emit("update:visible", false)
            },
        },
    };
</script>
<style lang="scss" scoped>
.FZYimgMp4list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
}
</style>